// Requires: generated/templates.js
// Requires: src/checkout-state.js

(function(checkoutState, template) {
	'use strict';

	var addressSelect = checkoutState.component.create({
		selector:  '[data-checkout-select-type="billing"]',
		stateType: checkoutState.state.type.addressSelect,
		template:  template
	});

	addressSelect.init();

})(window.BOL.Checkout.State, window.BOL.Online.Templates.checkoutAddressSelect);
